"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Feuerwehr = _interopRequireDefault(require("../model/Feuerwehr"));
var _FeuerwehrCreate = _interopRequireDefault(require("../model/FeuerwehrCreate"));
var _Gemeinde = _interopRequireDefault(require("../model/Gemeinde"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Feuerwehr service.
* @module api/FeuerwehrApi
* @version 0.0.1
*/
class FeuerwehrApi {
  /**
  * Constructs a new FeuerwehrApi. 
  * @alias module:api/FeuerwehrApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createFeuerwehrFeuerwehrPost operation.
   * @callback module:api/FeuerwehrApi~createFeuerwehrFeuerwehrPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Feuerwehr} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Feuerwehr
   * @param {module:model/FeuerwehrCreate} feuerwehrCreate 
   * @param {module:api/FeuerwehrApi~createFeuerwehrFeuerwehrPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Feuerwehr}
   */
  createFeuerwehrFeuerwehrPost(feuerwehrCreate, callback) {
    let postBody = feuerwehrCreate;
    // verify the required parameter 'feuerwehrCreate' is set
    if (feuerwehrCreate === undefined || feuerwehrCreate === null) {
      throw new Error("Missing the required parameter 'feuerwehrCreate' when calling createFeuerwehrFeuerwehrPost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Feuerwehr.default;
    return this.apiClient.callApi('/feuerwehr/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the createGemeindeGemeindePost operation.
   * @callback module:api/FeuerwehrApi~createGemeindeGemeindePostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Gemeinde} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Gemeinde
   * @param {String} name 
   * @param {module:api/FeuerwehrApi~createGemeindeGemeindePostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Gemeinde}
   */
  createGemeindeGemeindePost(name, callback) {
    let postBody = null;
    // verify the required parameter 'name' is set
    if (name === undefined || name === null) {
      throw new Error("Missing the required parameter 'name' when calling createGemeindeGemeindePost");
    }
    let pathParams = {};
    let queryParams = {
      'name': name
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Gemeinde.default;
    return this.apiClient.callApi('/gemeinde/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readFeuerwehrFeuerwehrFeuerwehrIdGet operation.
   * @callback module:api/FeuerwehrApi~readFeuerwehrFeuerwehrFeuerwehrIdGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Feuerwehr} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Feuerwehr
   * @param {Number} feuerwehrId 
   * @param {module:api/FeuerwehrApi~readFeuerwehrFeuerwehrFeuerwehrIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Feuerwehr}
   */
  readFeuerwehrFeuerwehrFeuerwehrIdGet(feuerwehrId, callback) {
    let postBody = null;
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling readFeuerwehrFeuerwehrFeuerwehrIdGet");
    }
    let pathParams = {
      'feuerwehr_id': feuerwehrId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Feuerwehr.default;
    return this.apiClient.callApi('/feuerwehr/{feuerwehr_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readFeuerwehrenFeuerwehrGet operation.
   * @callback module:api/FeuerwehrApi~readFeuerwehrenFeuerwehrGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Feuerwehr>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Feuerwehren
   * @param {Object} opts Optional parameters
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {module:api/FeuerwehrApi~readFeuerwehrenFeuerwehrGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Feuerwehr>}
   */
  readFeuerwehrenFeuerwehrGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'skip': opts['skip'],
      'limit': opts['limit']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Feuerwehr.default];
    return this.apiClient.callApi('/feuerwehr/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readFeuerwehrenNamesFeuerwehrNamesGet operation.
   * @callback module:api/FeuerwehrApi~readFeuerwehrenNamesFeuerwehrNamesGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Feuerwehr>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Feuerwehren Names
   * @param {Object} opts Optional parameters
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {String} [typ = 'kfv')] Typ der Feuerwehr. Entweder 'kfv' oder 'kjf'
   * @param {module:api/FeuerwehrApi~readFeuerwehrenNamesFeuerwehrNamesGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Feuerwehr>}
   */
  readFeuerwehrenNamesFeuerwehrNamesGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'skip': opts['skip'],
      'limit': opts['limit'],
      'typ': opts['typ']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Feuerwehr.default];
    return this.apiClient.callApi('/feuerwehrNames/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readGemeindenGemeindeGet operation.
   * @callback module:api/FeuerwehrApi~readGemeindenGemeindeGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Gemeinde>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Gemeinden
   * @param {Object} opts Optional parameters
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {module:api/FeuerwehrApi~readGemeindenGemeindeGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Gemeinde>}
   */
  readGemeindenGemeindeGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'skip': opts['skip'],
      'limit': opts['limit']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Gemeinde.default];
    return this.apiClient.callApi('/gemeinde/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateFeuerwehrFeuerwehrFeuerwehrIdPatch operation.
   * @callback module:api/FeuerwehrApi~updateFeuerwehrFeuerwehrFeuerwehrIdPatchCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Feuerwehr} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Feuerwehr
   * @param {Number} feuerwehrId 
   * @param {module:model/FeuerwehrCreate} feuerwehrCreate 
   * @param {module:api/FeuerwehrApi~updateFeuerwehrFeuerwehrFeuerwehrIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Feuerwehr}
   */
  updateFeuerwehrFeuerwehrFeuerwehrIdPatch(feuerwehrId, feuerwehrCreate, callback) {
    let postBody = feuerwehrCreate;
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling updateFeuerwehrFeuerwehrFeuerwehrIdPatch");
    }
    // verify the required parameter 'feuerwehrCreate' is set
    if (feuerwehrCreate === undefined || feuerwehrCreate === null) {
      throw new Error("Missing the required parameter 'feuerwehrCreate' when calling updateFeuerwehrFeuerwehrFeuerwehrIdPatch");
    }
    let pathParams = {
      'feuerwehr_id': feuerwehrId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Feuerwehr.default;
    return this.apiClient.callApi('/feuerwehr/{feuerwehr_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = FeuerwehrApi;